// Total elapsed as m:ss, counting minutes past 60 (e.g. 63:05) rather than wrapping to the
// minute-of-hour like moment's 'm:ss' would (which shows 0:00 again at the one-hour mark).
export const formatElapsedMs = (ms: number): string => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};
